import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ExternalCommentsPage } from '../../pages/order/comments/ExternalCommentsPage';
import { InternalCommentsPage } from '../../pages/order/comments/InternalCommentsPage';
import { VendorCommentsPage } from '../../pages/order/comments/VendorCommentsPage';
import { useSetOrderNavigationTab } from '../../utilities/hooks/useSetOrderNavigationTab';
import { useRouteMatch } from 'react-router';
import { CommentsNavigation } from '../../components/order/comments/CommentsNavigation';
import { OrderTabs } from 'store/order/orderNavigation/orderNavigationSlice';

export const CommentsRouter: React.FC = () => {
  useSetOrderNavigationTab({ tab: OrderTabs.Comments });
  const { path } = useRouteMatch();

  return (
    <CommentsNavigation>
      <Switch>
        <Route path={`${path}/external`} component={ExternalCommentsPage} />
        <Route path={`${path}/internal`} component={InternalCommentsPage} />
        <Route path={`${path}/vendor`} component={VendorCommentsPage} />
      </Switch>
    </CommentsNavigation>
  );
};
